import { persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn as create } from "zustand/traditional";

interface IAuthState {
  accessToken: string | null;
  refreshToken: string | null;
  setAccessToken: (accessToken: string) => void;
  setRefreshToken: (refreshToken: string) => void;
  reset: () => void;
}

const initialState: Pick<IAuthState, "accessToken" | "refreshToken"> = {
  accessToken: null,
  refreshToken: null,
} as const;

export const useAuthStore = create<IAuthState>()(
  persist<IAuthState>(
    (set) => ({
      ...initialState,
      setAccessToken: (accessToken: string) => set({ accessToken }),
      setRefreshToken: (refreshToken: string) => set({ refreshToken }),
      reset: () => set(initialState),
    }),
    {
      name: "auth",
    },
  ),
  shallow,
);
